
export class FormField
{
    public label = "";
    public name = "";
    public validationType = "";
    public validation = "";
    public options: any = {}
    public type = ""
    public maxLength=512;
    public required = false;
}

export class FormLayout
{

    public title = "";
    public subtitle = "";
    public fields: FormField[] = [];
}

export class FormLayoutData
{
    public id = "";
    public layout!: FormLayout;
    public model!: any;
}

export class FieldValidationResult
{
    public message = "";
    public valid = true;
}

function getLabel(obj: any): string
{
    let label = obj.field.label;        
    
    if (!label && obj.field.type=="user-email")
    {
         label="Email address"
    }
    else if (!label) {
        label="This field"
    }
    
    return label;
}

function validateEmail(obj: any): FieldValidationResult
{
    let result = new FieldValidationResult();
    let value = obj.proxyValue;
    let parts=value.split('@');
    let valid = parts.length==2;

    if (valid)
    {
        valid=parts[1].indexOf('.')>0       
    }

    result.valid=valid;
    
    if (!result.valid)
    {
        result.message="A valid email is required.";        
    }

    return result;
}

function getValidationMessage(obj: any, label: string): string
{
    let message = obj.field.validationMessage ?? "$label is invalid.";
    message=message.replace(/\$label/,label);
    return message;
}


function required(obj: any): FieldValidationResult
{
    let result = new FieldValidationResult();
    result.valid=obj.proxyValue ? true : false; 

    if (!result.valid)
    {
        result.message=  "$label is required.".replace(/\$label/, getLabel(obj) )
    }

    return result;
}

export function validate(obj: any): FieldValidationResult[]
{
    let result: FieldValidationResult[] = [];

    let validators=getValidators(obj);

    for (let i=0;i<validators.length;i++)
    {
        let validationResult = validators[i](obj);
        if (!validationResult.valid || validationResult.message)
        {
            result.push(validationResult);
            break;
        }
    }


    return result;
}

function getValidators(obj: any): any[]
{
    let validationType = obj.field.validationType ?? obj.field.type

    let validators = []; 
    if (obj.field.required && validationType!="user-email")
    {
        validators.push( (o: any)=>{return required(o)} );
    }

    switch(validationType)
    {
        case "user-email":
            if (!obj.userProfile)
            {
                validators.push( (o: any)=>required(o) );
                validators.push( (o: any)=>validateEmail(o) );
            }

          
        break;
    }

    return validators;
}

export function setProxyValue(obj: any)
{
    if (obj.data && obj.field)
    {
        obj.proxyValue=obj.data[obj.field.name];
    }
}

// var contactModel=
// {
//     userEmail:"",
//     message:""
// }

// var contatForm = 
// {
//     title:"Contact Us",
//     subtitle:"",
//     fields:[
//         {
//             type:"user-email",
//             name:"userEmail"
//         },
//         {
//            type:"radio-list",
//            label:"Reason for contacting us",
//            options: {
//              valueList:
//              [
//                 {text:"Question/requesting information", value:"requesting_info"},
//                 {text:"Customer support", value:"customer_support"},
//                 {text:"Report a bug", value:"bug_report"},
//                 {text:"Feedback", value:"fedback"},
//                 {text:"Become a content creator", value:"content_creator"},

//              ]
//            },

//         },
//         {
//             label:"Message",
//             name:"message",
//             maxLength:512,
//         }
//     ]
// }

